import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { getArticlesByNiche } from "../../data/articles";
import type { ArticleNiche } from "../../data/articles";

export function NicheGuides({ niche }: { niche: ArticleNiche }) {
  const list = getArticlesByNiche(niche);
  if (list.length === 0) return null;
  return (
    <section data-testid="niche-guides" aria-labelledby="niche-guides-title" className="border-t border-slate-800">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <h2 id="niche-guides-title" className="text-base font-semibold text-slate-100 md:text-lg">Guias e Base Legal</h2>
        <ul className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
          {list.map((a) => (
            <li key={a.slug}>
              <Link
                to={`/${a.niche}/${a.slug}`}
                data-testid={`guide-link-${a.slug}`}
                className="group flex h-full flex-col rounded-xl border border-slate-800 bg-slate-900/40 p-5 transition-colors duration-200 hover:border-emerald-500/40"
              >
                <span className="text-sm font-semibold leading-snug text-slate-100 transition-colors duration-200 group-hover:text-emerald-400 sm:text-base">{a.title}</span>
                <span className="mt-2 line-clamp-2 text-sm leading-relaxed text-slate-400">{a.subtitle}</span>
                <span className="mt-4 flex items-center justify-between font-mono text-xs text-slate-500">
                  <span className="flex items-center gap-1.5"><Clock aria-hidden="true" className="h-3.5 w-3.5 text-emerald-500" />{a.readingTime} de leitura</span>
                  <ArrowRight aria-hidden="true" className="h-4 w-4 text-emerald-500 transition-transform duration-200 group-hover:translate-x-0.5" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
